import { Component, EventEmitter, Input, Output } from "@angular/core";

@Component({
  selector: "app-tab-navigation-controls",
  templateUrl: "./tab-navigation-controls.component.html",
  styleUrls: ["./tab-navigation-controls.component.scss"],
})
export class TabNavigationControlsComponent {
  @Input() currentTabIndex = 0;
  @Input() totalTabs = 0;

  @Output() previous = new EventEmitter<void>();
  @Output() next = new EventEmitter<void>();
}
